<template>
  <div class="flex h-10">
    <button
      v-for="tab of tabNames"
      :key="tab"
      class="border-b-4 select-none cursor-pointer font-semibold transition-colors duration-200 px-4"
      :class="[
        isActive(tab)
          ? 'border-lagon-500 text-lagon-700'
          : 'border-transparent text-gray-700 hover:text-gray-900',
        tabsClass,
      ]"
      @click="$emit('input', tab)"
    >
      {{ tab[0].toUpperCase() + tab.slice(1) }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
      validator: ([tab]) =>
        typeof tab == 'string' ||
        (tab.hasOwnProperty('label') && typeof tab.label == 'string'),
    },
    tabsClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    tabNames() {
      return typeof this.tabs[0] == 'string'
        ? this.tabs
        : this.tabs.map(t => t.label)
    },
  },
  methods: {
    isActive(tabName) {
      return this.value == tabName
    },
  },
}
</script>
